<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Company_directory" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<g id="ico-member-directory-copy" transform="translate(0, 3.52)" :fill="color" fill-rule="nonzero">
						<path d="M17.6,0 L22,4.62 L39.6,4.62 C42.02,4.62 44,6.699 44,9.24 L44,32.34 C44,34.881 42.02,36.96 39.6,36.96 L4.4,36.96 C1.98,36.96 0,34.881 0,32.34 L0.022,4.62 C0.022,2.079 1.98,0 4.4,0 L17.6,0 Z M36.7966012,27.7744966 L21.4128047,27.8178264 L20.0000001,29.7136784 L20.0000001,30.8033139 L38.001844,30.8033139 L38.001844,29.7136784 L36.7966012,27.7744966 Z M32.21571,18.920321 L29.6447098,18.920321 L29.6447098,26.8411324 L32.21571,26.8418427 L32.21571,18.920321 Z M36.0742858,18.920321 L33.5019018,18.920321 L33.5019018,26.8411324 L36.0742858,26.8418427 L36.0742858,18.920321 Z M28.3592098,18.920321 L25.786134,18.920321 L25.786134,26.8411324 L28.3592098,26.8418427 L28.3592098,18.920321 Z M24.500634,18.920321 L21.9289419,18.920321 L21.9289419,26.8411324 L24.500634,26.8418427 L24.500634,18.920321 Z M29.0019599,12.32 L20.643442,17.3661344 C20.643442,17.3661344 20.0664198,17.8995868 20.643442,18.2611412 L37.3597858,18.2611412 C37.3597858,18.260431 37.827492,17.8683326 37.3597858,17.3661344 L29.0019599,12.32 Z" id="path-1"></path>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>